const isFunction = (value) => {
  return !!value && typeof value === 'function'
}

export const evalData = (code, data) => {
  let fn
  try {
    const wrCode = `fn=${code}`
    // eslint-disable-next-line no-eval
    eval(wrCode)
    if (isFunction(fn)) {
      return fn(data)
    }
  } catch (error) {
    console.log(error)
  }
  return null
}
